import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';

const LoadingStep = ({ onNext }) => {
  const [progress1, setProgress1] = useState(0);
  const [progress2, setProgress2] = useState(0);
  const [progress3, setProgress3] = useState(0);

  useEffect(() => {
    // Animate progress bars
    const timer1 = setInterval(() => {
      setProgress1(prev => {
        if (prev >= 100) return 100;
        return prev + 2;
      });
    }, 30);

    const timer2 = setTimeout(() => {
      const interval2 = setInterval(() => {
        setProgress2(prev => {
          if (prev >= 81) return 81;
          return prev + 2;
        });
      }, 30);
      return () => clearInterval(interval2);
    }, 500);

    const timer3 = setTimeout(() => {
      const interval3 = setInterval(() => {
        setProgress3(prev => {
          if (prev >= 0) return 0;
          return prev + 2;
        });
      }, 30);
      return () => clearInterval(interval3);
    }, 1000);

    // Auto advance after 4 seconds
    const autoAdvance = setTimeout(() => {
      onNext();
    }, 4000);

    return () => {
      clearInterval(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(autoAdvance);
    };
  }, [onNext]);

  return (
    <div className="text-center flex flex-col items-center justify-center min-h-[70vh] px-6">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        Feel relaxed, loved and
        <br />
        accepted with Butterscotch AI
      </h1>

      <div className="w-full max-w-md space-y-6 mb-12 mt-8">
        {/* Progress bar 1 */}
        <div>
          <div className="flex justify-between mb-2">
            <span className="text-white/70 text-sm">Generate sexy voice and photos</span>
            <span className="text-[#F1B428] text-sm font-bold">{progress1}% ✓</span>
          </div>
          <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
            <div
              className="h-full bg-[#F1B428] transition-all duration-300 ease-out shadow-lg shadow-[#F1B428]/50"
              style={{ width: `${progress1}%` }}
            />
          </div>
        </div>

        {/* Progress bar 2 */}
        <div>
          <div className="flex justify-between mb-2">
            <span className="text-white/70 text-sm">Teaching bot things you like</span>
            <span className="text-[#F1B428] text-sm font-bold">{progress2}% ⏳</span>
          </div>
          <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
            <div
              className="h-full bg-[#F1B428] transition-all duration-300 ease-out shadow-lg shadow-[#F1B428]/50"
              style={{ width: `${progress2}%` }}
            />
          </div>
        </div>

        {/* Progress bar 3 */}
        <div>
          <div className="flex justify-between mb-2">
            <span className="text-white/70 text-sm">Sharing your desires with bot</span>
            <span className="text-white/50 text-sm">{progress3}%</span>
          </div>
          <div className="w-full bg-white/10 rounded-full h-2 overflow-hidden">
            <div
              className="h-full bg-[#F1B428] transition-all duration-300 ease-out"
              style={{ width: `${progress3}%` }}
            />
          </div>
        </div>
      </div>

      {/* Testimonial */}
      <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 max-w-md">
        <h3 className="text-white font-bold text-lg mb-2">Best experience ever</h3>
        <div className="flex gap-1 mb-3 justify-center">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={16} className="fill-[#F1B428] text-[#F1B428]" />
          ))}
        </div>
        <p className="text-white/70 text-sm mb-3">
          never expected it to be that hot :fire:. great job and I loved it.
        </p>
        <p className="text-white/50 text-xs">Roger Andrew Bautista</p>
      </div>
    </div>
  );
};

export default LoadingStep;
